import {request} from '@/utils/http'

export default {
    index:(params = {}) => request.get('/menu/tree',{params}),
    add:(data) => request.post('/menus',data),
    delete:(id) => request.delete(`/menus/${id}`,),
    update:(id,data) => request.put(`/menus/${id}`,data),
    simple:(params = {}) => request.get('/menu-simple',{params}),
}